/* eslint-disable react-hooks/exhaustive-deps */
import { Clear, Edit, Save } from "@mui/icons-material";
import { IconButton, InputAdornment, OutlinedInput, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ChangeEvent, MouseEventHandler, useEffect, useState } from "react";
import { isDeviceNameValid } from "../Helper";

export type EditableTextProps = {
    value: string;
    onSave: (textToSave: string) => void;
}

const EditableText = (props: EditableTextProps): JSX.Element => {
    const { value, onSave } = props;
    const [dirtyValue, setDirtyValue] = useState<string | undefined>(undefined); //if undefined, we are not editing, otherwise we are and we show this value

    useEffect(() => {
        //if the value changes, we exit editing mode and show the value
        setDirtyValue(undefined);
    }, [value]);

    const handleDirtyValueChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        let newDirtyValue = event.target.value;
        if (dirtyValue !== newDirtyValue && isDeviceNameValid(newDirtyValue)) {
            setDirtyValue(newDirtyValue);
        }
    };

    const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
        if (dirtyValue !== undefined) {
            //save clicked
            const newName = dirtyValue.trim();
            if (newName === value) {
                //no change, we simply exit editing mode
                setDirtyValue(undefined);
            } else {
                if (newName === "") {
                    //this is a special case, we want to exit editing mode but it does not happen in case the default name is currently set and we try to delete it.
                    //After mon sys update, the default name is shown again and this input field does not recognize the change.
                    //To fix this, we set the value to undefined to force finish editing mode as the default name is expected to be set again.
                    setDirtyValue(undefined);
                }

                onSave(newName);//let the user component know that we want to save the new name -> it updates the value once it is done and the value change makes us leave text editing mode
            }
        } else {
            //enter editing mode
            setDirtyValue(value);
        }
        event.stopPropagation();//stop the accordion from opening / closing
    };

    return <Grid container
        style={{
            justifyContent: 'space-between',
            alignItems: 'center'
        }}>
        <Grid size='grow'>
            {dirtyValue !== undefined ?
                <OutlinedInput
                    value={dirtyValue}
                    onChange={handleDirtyValueChange}
                    autoFocus
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                style={{ padding: 0 /*makes the icon smaller*/ }}
                                onClick={(event) => {
                                    setDirtyValue(undefined);
                                    event.stopPropagation(); //stops the accordion from opening
                                }}>
                                <Clear />
                            </IconButton>
                        </InputAdornment>
                    }
                /> : <Typography>{value}</Typography>
            }
        </Grid>
        <Grid size='auto'>
            <IconButton
                onClick={handleClick}
                size="small"
            >
                {dirtyValue !== undefined ? <Save /> : <Edit />}
            </IconButton>
        </Grid>
    </Grid >
};


export default EditableText;
